import React from 'react';
import { CheckboxContained, CheckboxContainedGroup } from '@homeexchange/design';
import i18n from '../../../../i18n';
var PET_SITTING_OPTIONS = [
    { name: 'cat', icon: 'Cat', label: 'search:global_filter_catsit' },
    { name: 'dog', icon: 'Dog', label: 'search:global_filter_dogsit' }
];
export var PetSitting = function (_a) {
    var onUpdate = _a.onUpdate, values = _a.values;
    return (React.createElement("div", null,
        React.createElement(CheckboxContainedGroup, { collapsible: false, helperContent: React.createElement(React.Fragment, null, i18n.t('search:filter_petsitting_desc')), itemPerLine: 4 }, PET_SITTING_OPTIONS.map(function (option) { return (React.createElement(CheckboxContained, { name: 'pets_to_care_for', type: "checkbox", key: "pet-sitting-".concat(option.name), label: i18n.t(option.label), onChange: onUpdate, value: option.name, icon: option.icon, checked: values && values.includes(option.name), id: "gtm-track-".concat(option.name, "-sitting") })); }))));
};
export default PetSitting;
